import React from 'react';

import { Box } from '@mui/material';

export default function DealFieldBox({ value }: { value: string }) {
  return <Box sx={{ fontSize: 13, overflowWrap: 'break-word' }}>{value}</Box>;
}
